import { useOne, useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { OAuthClientOut, UserOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { OAUTH_CLIENT_DEFAULT_TAB, OAUTH_CLIENT_SHOW_TABS } from '../constants';
import { OAuthClientShowHeader } from './OAuthClientShowHeader';
import { OAuthClientGeneralTab } from './OAuthClientGeneralTab';
import { OAuthClientTokensTab } from './OAuthClientTokensTab';

export const OAuthClientShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<OAuthClientOut>({
    resource: 'iam.oauth_clients',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  const { result: user } = useOne<UserOut>({
    resource: 'iam.users',
    id: record?.user_id ?? 0,
    queryOptions: { enabled: record?.user_id != null },
  });

  useRecordDocumentTitle(
    'iam.oauth_clients',
    record ? record.client_name || record.client_id : undefined
  );

  const [activeTab, onTabChange] = useShowTab(
    OAUTH_CLIENT_SHOW_TABS,
    OAUTH_CLIENT_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <OAuthClientShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <OAuthClientGeneralTab record={record} user={user} />
            )}
            {activeTab === 'tokens' && (
              <OAuthClientTokensTab clientId={record.client_id} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
